import Bugsnag from '@bugsnag/js'

import StorageService from './services/StorageService'

export const XSRF_REQUEST_HEADER_NAME = 'X-CSRF-Token' // set this header
export const XSRF_RESPONSE_HEADER_NAME = 'X-XSRF' // read this from response header

// Rails rejects a request whose CSRF token no longer matches the session with this status and
// returns a usable token on the same response, so the caller can repeat the request once.
export const CSRF_REJECTION_STATUS = 422

// The REST API also answers a failed validation with 422, and every api/v2 response carries a
// token header. Only the CSRF rescue renders this body, so it tells the two apart.
export const CSRF_REJECTION_ERROR = 'invalid_request'

export const isCsrfRejection = (status?: number, body?: unknown): boolean =>
  status === CSRF_REJECTION_STATUS && (body as { error?: string })?.error === CSRF_REJECTION_ERROR

const { get, set } = StorageService

export const readXsrfToken = async (): Promise<string | null> => {
  const stored = await get({ key: XSRF_RESPONSE_HEADER_NAME })

  return stored?.value || null
}

export const storeXsrfToken = (token: string): Promise<void> =>
  set({ key: XSRF_RESPONSE_HEADER_NAME, value: token })

export const reportXsrfRecovery = (source: string): void => {
  Bugsnag.notify(
    new Error(`XSRF token refreshed after ${CSRF_REJECTION_STATUS} on ${source}`),
    (event) => {
      event.severity = 'info'
    }
  )
}
